import * as React from "react"
import { Button } from "@mui/material";
import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';

function CustomToolbar(createButtonCallback, createButtonText) {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport />
            {createButtonCallback && <Button
                onClick={createButtonCallback}
            ><AddCircleSharpIcon /> {createButtonText}</Button>}
        </GridToolbarContainer>
    )
}
export function SimpleCustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarDensitySelector />
        </GridToolbarContainer>
    )
}
export default CustomToolbar